import { isAxiosError } from "axios"

/**
 * Best user-facing text for a failed API call.
 *
 * The backend answers 4xx/5xx with `{ "error": "<message>" }` (see
 * `error.py::handle_api_error` and route-level `jsonify({"error": ...})`).
 * Axios discards that body from `error.message` ("Request failed with status
 * code 500"), so callers that show `error.message` in a toast hide the only
 * useful part. Prefer the backend text, then the Error message, then the
 * caller's fallback.
 */
export function getApiErrorMessage(error: unknown, fallback = ""): string {
  if (isAxiosError(error)) {
    const body = error.response?.data as { error?: unknown } | undefined
    if (typeof body?.error === "string" && body.error.trim()) {
      return body.error
    }
  }
  if (error instanceof Error && error.message.trim()) {
    return error.message
  }
  return fallback
}
